import axios from "axios";
import {useEffect, useState} from "react";
import { useNavigate, useParams} from "react-router-dom";
import {Breadcrumb, Col, Modal, Pagination, Row} from "antd";
import Footer from "../component/Footer";
import CardItem from '../component/CardItem';
import {useCookies} from "react-cookie";
import {useDevice} from "../hooks";

export default function Course() {
    useDevice();

    const {slug} = useParams();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalSpeakOpen, setIsModalSpeakOpen] = useState(false);
    const [dataCourse, setdataCourse] = useState([]);
    const [dataUserTopic, setDataUserTopic] = useState({});
    const [pagination, setPagination] = useState({
        page: 1,
        pageSize: 12,
    });
    const [cookies] = useCookies(["user"]);
    const navigate = useNavigate();

    const course = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/course/getBySlugTopic/${slug}`, {params: pagination});
            console.log(response.data[0])
            setdataCourse(response?.data[0]);
        } catch (error) {
            console.error(error);
        }
    }


    useEffect(() => {
        course();
    }, []);

    return (
        <>
            <div class="max-w-screen-xl items-center mx-auto p-4 h-screen">
                <Breadcrumb
                    className="py-5"
                    items={[
                        {
                            title: <a href="/">Home</a>,
                        },
                        {
                            title: <a href="/topic">Topic</a>,
                        },
                        {
                            title: dataCourse?.title,
                        },
                    ]}
                />
                <p className="text-4xl text-center py-10">{dataCourse?.title}</p>

                <Row className='pt-[30px]' gutter={[16, 16]}>
                    {dataCourse?.course?.map((c, index) =>
                        <Col xs={24} sm={12} md={8} xl={6} key={index} className='mt-2'>
                            <CardItem
                                to={'/lesson/' + c.slug}
                                title={c.title}
                                subtitle={c.description}
                                meta={`${c.totalLessons || 0} lessons`}
                                image={c?.image_url}
                                imageAlt={c?.title}
                            />
                        </Col>
                    )}
                </Row>

                <Pagination
                    className="flex justify-center pt-[50px]"
                    current={pagination.page}
                    total={dataCourse?.total}
                    pageSize={pagination.pageSize}
                    onChange={(p, ps) => {
                        setPagination({
                            page: p,
                            pageSize: ps
                        })
                    }}
                />
            </div>
            {Footer()}

            <Modal open={isModalOpen}
                   onOk={() => cookies?.user ? navigate(`/profile/${cookies.user.id}`) : navigate('/login')}
                   onCancel={() => setIsModalOpen(false)} okButtonProps={{className: "bg-blue-500"}}>
                <p className="text-xl font-bold py-2 pt-8">Vui lòng truy cập vào profile và </p>
                <p className="text-xl font-bold py-2 pb-8">đăng ký gói vip để được sử dụng dịch vụ này</p>
            </Modal>

            <Modal open={isModalSpeakOpen} onOk={() => setIsModalSpeakOpen(false)}
                   onCancel={() => setIsModalSpeakOpen(false)} okButtonProps={{className: "bg-blue-500"}}>
                <p className="text-xl font-bold py-5 pt-8">Vui lòng tải app để được dùng chức năng này!</p>
            </Modal>
        </>
    );
};
